import { useTranslation } from "react-i18next";
import {
  FaCarSide,
  FaUserTie,
  FaBusAlt,
  FaHandshake,
  FaClock,
} from "react-icons/fa";
import {
  Box,
  Heading,
  SimpleGrid,
  Text,
  Icon,
  Stack,
  useColorModeValue,
} from "@chakra-ui/react";
import { trackClick } from '../ga';
const services = [
  {
    key: "fleet_management",
    icon: FaCarSide,
  },
  {
    key: "chauffeur_services",
    icon: FaUserTie,
  },
  {
    key: "bus_rentals",
    icon: FaBusAlt,
  },
  {
    key: "short_long_term_leasing",
    icon: FaClock,
  },
  {
    key: "commercial_renting",
    icon: FaHandshake,
  },
];

export default function ServicesOverview() {
  const { t } = useTranslation();
  const orgColor = "#ec562c";
  const bluColor = "#2f4280";
  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.700", "gray.100");

  return (
    <Box
      py={16}
      px={6}
      bgGradient="linear(to-b, #ffffff, #2f4280)"
      onClick={() => trackClick(`Clicked ServicesOverview `)}
    >
      <Heading
        textAlign="center"
        mb={4}
        fontSize="4xl"
        color={bluColor}
        fontWeight="bold"
      >
        {t("extended_services.title")}
      </Heading>
      <Text
        textAlign="center"
        fontSize="lg"
        color={textColor}
        maxW="3xl"
        mx="auto"
        mb={10}
      >
        {t("extended_services.intro")}
      </Text>

      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={8} maxW="7xl" mx="auto">
        {services.map(({ key, icon }) => (
          <Box
            key={key}
            p={6}
            bg={cardBg}
            borderRadius="2xl"
            boxShadow="lg"
            borderLeft={`6px solid ${orgColor}`}
            _hover={{ transform: "translateY(-5px)", transition: "0.3s" }}
            onClick={() => trackClick(`Clicked ${key} `)}
          >
            <Stack direction="row" align="center" mb={4}>
              <Icon as={icon} boxSize={8} color={bluColor} />
              <Heading size="md" color={bluColor}>
                {t(`extended_services.sections.${key}.title`)}
              </Heading>
            </Stack>
            <Text fontSize="sm" color={textColor}>
              {t(`extended_services.sections.${key}.description`)}
            </Text>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
}